@if (isLoaded()) {
    <div
        id="trading-symbols-lists-view"
        class="trading-symbols-lists-view d-flex flex-column align-items-start justify-content-start p-1 p-md-3"
    >
        <h1>Trading Symbols Lists</h1>

        <button mat-raised-button color="primary" (click)="create()">
            <mat-icon>add</mat-icon>
            Create New Symbols List
        </button>

        <div class="table-responsive w-100">
            <table mat-table [dataSource]="symbolsLists()" class="mat-elevation-z8 my-3 w-100">
                <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef>Name</th>
                    <td mat-cell *matCellDef="let element">{{ element.name }}</td>
                </ng-container>
                <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef>Actions</th>
                    <td mat-cell *matCellDef="let element">
                        <div class="d-flex flex-row align-items-center gap-1">
                            <button mat-icon-button color="primary" (click)="edit(element)" matTooltip="Edit">
                                <mat-icon>edit</mat-icon>
                            </button>
                            <button mat-icon-button color="warn" (click)="delete(element)" matTooltip="Delete">
                                <mat-icon>delete</mat-icon>
                            </button>
                        </div>
                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            </table>
        </div>
    </div>
}
